// extracted by mini-css-extract-plugin
export default {"week":"week_item-module___week___bb76fc39","lastWeek":"week_item-module___lastWeek___ea37d4e8"};